import { grantAdConsentInBrowser, revokeAdConsentInBrowser } from "../utils/ad-consent";

export const initCookieConsentBanner = () => {
  const cookieConsentBanner = document.getElementById("cookie-consent-banner") as HTMLDivElement;

  if (!cookieConsentBanner) {
    return;
  }

  const accept = cookieConsentBanner.querySelector(".accept") as HTMLButtonElement;
  const decline = cookieConsentBanner.querySelector(".decline") as HTMLButtonElement;

  accept.addEventListener("click", () => {
    const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");

    // biome-ignore lint/suspicious/noDocumentCookie: <Fix after all files will be refactored to biome rules>
    document.cookie =
      "cookie_consent=true; max-age=31536000; path=/; domain=" +
      hostnameBase +
      "; secure; samesite=lax";

    cookieConsentBanner.style.display = "none";

    grantAdConsentInBrowser();
  });
  decline.addEventListener("click", () => {
    const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");

    // biome-ignore lint/suspicious/noDocumentCookie: <Fix after all files will be refactored to biome rules>
    document.cookie =
      "cookie_consent_declined=true; max-age=31536000; path=/; domain=" +
      hostnameBase +
      "; secure; samesite=lax";

    cookieConsentBanner.style.display = "none";

    revokeAdConsentInBrowser();
  });
};
